<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text>
      <v-data-table
        item-key="id"
        class="elevation-0"
        no-data-text="Nenhum fornecedor encontrado"
        loading-text="Carregando fornecedores..."
        :headers="headers"
        :items="registros.content"
        :server-items-length="registros.total"
        :loading="loading"
        :options="optionsList"
        :footer-props="footerOptions"
        @update:options="updateOptions"
      >
        <template v-slot:item.nome="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="text-no-wrap">{{ item.nome | truncate }}</span>
            </template>
            <span>{{ item.codigoInterno ? `(${item.codigoInterno})` : '' }} {{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.total="{ item }">
          <span class="text-no-wrap">{{ item.total | currency}}</span>
        </template>
        <template v-slot:item.mediaQuantidadeProdutos="{ item }">
          {{ item.mediaQuantidadeProdutos | number('0.00') }}
        </template>
        <template v-slot:item.prazoEntrega="{ item }">
          {{ item.prazoEntrega | number('0.00') }}
        </template>
        <template v-slot:item.pmp="{ item }">
          {{ item.pmp | number('0.00') }}
        </template>
        <template v-slot:item.perComprasAcumuladas="{ item }">
          <px-calculo-percent property="total"
                              :fornecedor="item"
                              :totalizadores="totalizadores"/>
        </template>
        <template v-slot:item.perItensComprados="{ item }">
          <px-calculo-percent property="quantidadeProdutos"
                              :fornecedor="item"
                              :totalizadores="totalizadores"/>
        </template>
        <template v-slot:item.perCompras="{ item }">
          <px-calculo-percent property="quantidadeCompras"
                              :fornecedor="item"
                              :totalizadores="totalizadores"/>
        </template>
        <template v-slot:item.nivelDependencia="{ item }">
          <px-calculo-nivel-dependencia :fornecedor="item"
                                        :totalizadores="totalizadores" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import PxCalculoPercent from './PxCalculoPercent.vue';
import PxCalculoNivelDependencia from './PxCalculoNivelDependencia.vue';

export default {
  props: {
    registros: Object,
    loading: Boolean,
    totalizadores: Object,
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Fornecedor',
          sortable: false,
          value: 'nome',
        },
        {
          text: 'Total comprado',
          value: 'total',
          sortable: true,
        },
        {
          text: 'Itens comprados',
          value: 'quantidadeProdutos',
          sortable: true,
        },
        {
          text: 'Compras realizadas',
          value: 'quantidadeCompras',
          sortable: true,
        },
        {
          text: 'Média de itens',
          value: 'mediaQuantidadeProdutos',
          sortable: true,
        },
        {
          text: 'Prazo médio de pagamento',
          value: 'pmp',
          sortable: true,
        },
        {
          text: 'Prazo médio de entrega',
          value: 'prazoEntrega',
          sortable: true,
        },
        {
          text: 'Valor de compras',
          value: 'perComprasAcumuladas',
          sortable: false,
        },
        {
          text: 'Quantidade de itens',
          value: 'perItensComprados',
          sortable: false,
        },
        {
          text: 'Quantidade de compras',
          value: 'perCompras',
          sortable: false,
        },
        {
          text: 'Nível de dependência',
          value: 'nivelDependencia',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.$emit('change-options', options);
    },
    onChangeFilters() {
      this.$emit('change');
    },
  },
  components: {
    PxCalculoPercent,
    PxCalculoNivelDependencia,
  },
};
</script>
